/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .sml-icon[_ngcontent-%COMP%]{font-size:17px;height:42px!important;margin:auto}[_nghost-%COMP%]   .sml-icn-btn[_ngcontent-%COMP%]{height:25px!important}[_nghost-%COMP%]   .error-message[_ngcontent-%COMP%]{color:#b00020;font-size:14px;position:relative;bottom:14px;margin-bottom:8px;left:8px}"];
export { styles as styles };
